
import React from 'react'
import { useSelector } from 'react-redux'
import Menu from 'components/layout/Menu'
import useMenu from 'hooks/useMenu'
import selectHeaderMenu from 'redux/selectors/selectHeaderMenu'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectIsExternalAuth from 'redux/selectors/selectIsExternalAuth'

const MenuContainer = () => {
  const isLogged = useSelector(selectIsLogged)
  const isExternalAuth = useSelector(selectIsExternalAuth)
  const flavour = useSelector(selectFlavour)
  const menuItems = useMenu(selectHeaderMenu)

  return (
    <Menu
      menuItems={menuItems}
      isLogged={isLogged}
      isExternalAuth={isExternalAuth}
      flavour={flavour}
    />
  )
}

export default MenuContainer
